var map = {
	"./1.png": 5193,
	"./10.png": 3046,
	"./11.png": 5540,
	"./12.png": 1392,
	"./13.png": 1037,
	"./14.png": 2925,
	"./15.png": 6144,
	"./16.png": 8896,
	"./17.png": 7904,
	"./18.png": 7387,
	"./19.png": 1886,
	"./2.png": 936,
	"./20.png": 9041,
	"./3.png": 1378,
	"./4.png": 6931,
	"./5.png": 5362,
	"./6.png": 9247,
	"./7.png": 2889,
	"./8.png": 9921,
	"./9.png": 4629
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4272;